/**
 * System Alert Vuex
 */
import * as API from '@/endpoints'
import VueCookie from 'vue-cookie'
// import $ from 'jquery'
import Axios from 'axios'
import Vue from 'vue'

export default {
	namespaced: true,
	state: {
		showSystemAlert: false,
		persist: false,
		remindLater: false,
		shareableActivity: {},
		allShareableActivity: {},
		currentSystemShown: 0,
	},
	mutations: {
		setShowSystemAlert(state, v) {
			if(!v){
			  Vue.set(state, 'currentSystemShown', 0);
			}
			Vue.set(state, 'showSystemAlert', v);
		},
		setPersist(state, v) {
			Vue.set(state, 'persist', v);
		},
		setRemindLater(state, v) {
			Vue.set(state, 'remindLater', v);
			if (v) Vue.set(state, 'showSystemAlert', false)
		},
		setShareableActivity(state, v) {
			Vue.set(state, 'shareableActivity', v);
			// check if there is shareable data
			// if (v && v.length > 0) Vue.set(state, 'showSystemAlert', true);
		},
		setCurrentSystemShown(state, v) {
			Vue.set(state, 'currentSystemShown', v);
		},
		removeShareItem (state, val) {
			val.this.$vlf.createInstance({
                storeName: 'systemAlert'
            }).then((v) => {
              v.getItem('shareableActivity').then(activity => {
                    let foundInStack = activity.data.findIndex( (i) => {
                      return i.id === val.act.id
                    });
                    if(foundInStack != -1){
						activity.data.splice(foundInStack,1);
						v.setItem('shareableActivity', activity);
                    }
              })
            })
			let foundshareableActivityInStack = state.shareableActivity.data.findIndex( (i) => {
				return i.id === val.act.id
			});
			if(foundshareableActivityInStack != -1){
				state.shareableActivity.data.splice(foundshareableActivityInStack,1);
			}
		},
		addShareItem(state,val){
			val.this.$vlf.createInstance({
                storeName: 'systemAlert'
            }).then((v) => {
              v.getItem('shareableActivity').then(activity => {
				if (activity) {
                    let foundInStack = activity.data.findIndex( (i) => {
                      return i.id === val.act.id
                    });
                    if(foundInStack == -1){
						activity.data.unshift(val.act);
						v.setItem('shareableActivity', activity);
					}
				}
				let foundshareableActivityInStack = state.shareableActivity.data.findIndex( (i) => {
					return i.id === val.act.id
				});
				if(foundshareableActivityInStack == -1){
					v.removeItem('remindLater');
					v.setItem('showAlert', true);
					clearInterval(checkReminder)
					state.shareableActivity.data.unshift(val.act);
					Vue.set(state, 'showSystemAlert', true)
				}
              })
            })

		},
	},
	actions: {
		getShareableActivity({ rootState, commit, dispatch, state }) {
      if( !localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE') ) return false;

			return new Promise((resolve, reject) => {
				Axios.get(API.endpoints.base + 'feed/activity/share')
					.then(res => {
						resolve(res.data)
					}, error => {
						reject(error)
					})
			})
		},
		getAllShareableActivity({ rootState, commit, dispatch, state }) {
			if( !localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE') ) return false;
	  
			Axios.get(API.endpoints.base + 'feed/activity/share/all')
				.then(res => {
					Vue.set(state, 'allShareableActivity', res.data)
				}, error => {
					// reject(error)
				})
		},
		doShareAction({ commit, dispatch, state }, param) {
			return new Promise((resolve, reject) => {
				Axios.post(API.endpoints.base + 'user/share/activity', param)
					.then(res => {
						resolve(res.data)
					}, error => {
						reject(error)
					})
			})
		}
		// getShareCount({commit, dispatch, state}, url) {
		//     console.log('https://graph.facebook.com/?id=' + url)
		//     $.get({url: 'https://graph.facebook.com/?id=' + url})
		//     .done(res => {
		//         console.log(res)
		//     })
		// }
	}
}
